import {useState} from "react";
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Button from "@mui/material/Button";
import Tx from "./Tx";
import DialogActions from "@mui/material/DialogActions";

function Message() {

    const [txt, s_txt] = useState('');
    const [show, s_show] = useState(false);
    const [isYesNo, s_isYesNo] = useState(false);
    const [cb, s_cb] = useState(null);

    window.messageBoxListener((txt, cb1, isYesNo) => {
        s_cb({cb: cb1});
        s_show(true);
        s_txt(txt);
        s_isYesNo(isYesNo);
    });

    const onCloseDialog = (yesOrNo) => {
        s_show(false);
        s_txt('');
        s_isYesNo(false);
        cb && cb.cb && cb.cb(yesOrNo);
    };

    return (
        <Dialog
            open={show}
            onClose={() => onCloseDialog()}
            aria-labelledby="alert-message-dialog-title"
            aria-describedby="alert-message-dialog-description"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {txt}
                </DialogContentText>
            </DialogContent>
            {isYesNo && (
                <DialogActions>
                    <Button
                        onClick={() => onCloseDialog()}><Tx>g.cancel</Tx></Button>
                    <Button autoFocus
                            onClick={() => onCloseDialog(true)}
                    >
                        <Tx>g.confirm</Tx>
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );

}

export default Message;